<!--
 * @Author: your name
 * @Date: 2020-10-09 17:48:14
 * @LastEditTime: 2021-03-19 16:01:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \project\src\views\Home\Member\children\Management.vue
-->
<template>
  <div id='management' class="content">
    <div id="dialogBg" v-if="isShowMonitor"></div>
    <el-row class="goBackHome" v-if="roleType==2">
      <el-row v-if="tabIndex==0 ||tabIndex==1">
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <span class="clickBack" @click="$router.push('/home/adminManagement' )"><img src="@/assets/img/back.png" alt="">返回</span>
        </el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
          <span style="color: #333333;">会员管理 > </span>{{$route.query.comName}}
        </el-col>
      </el-row>
      <el-row v-else>
        <el-col :xs="2" :sm="2" :md="2" :lg="2" :xl="2">
          <span class="clickBack" @click="$router.push('/home/adminManagement' )"><img src="@/assets/img/back.png" alt="">返回</span>
        </el-col>
        <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
          <span style="color: #333333;">会员管理 > </span><span style="color:#0066cc;">通知会员</span>
        </el-col>
      </el-row>
    </el-row>
    <template v-if="tabIndex==0">
      <el-tabs @tab-click="memberClick" v-model="activeName" class="member">
        <el-tab-pane label="会员档案" name="1" class="memberProfile">
          <el-row class="memberInfo">
            <el-col :xs="7" :sm="7" :md="7" :lg="7" :xl="7">
              入会时间:
              <span v-if="roleType==2">{{$route.query.initiationTime.substr(0,10)}}</span>
              <span v-if="roleType==3">{{userInfoData.initiationTime.substr(0,10)}}</span>
            </el-col>
            <el-col :xs="17" :sm="17" :md="17" :lg="17" :xl="17">
              会员等级:
              <template v-if="roleType==2">
                <span v-if="$route.query.memberGrade==1">会长</span>
                <span v-else-if="$route.query.memberGrade==2">副会长</span>
                <span v-else-if="$route.query.memberGrade==3">理事会员</span>
                <span v-else-if="$route.query.memberGrade==4">普通会员</span>
              </template>
              <template v-if="roleType==3">
                <span v-if="userInfoData.memberGrade==1">会长</span>
                <span v-else-if="userInfoData.memberGrade==2">副会长</span>
                <span v-else-if="userInfoData.memberGrade==3">理事会员</span>
                <span v-else-if="userInfoData.memberGrade==4">普通会员</span>
              </template>
            </el-col>
          </el-row>
          <el-row class="memberTabs memberRow">
            <el-col class="memberCol" :span="4" :class="{activeStyle:index==memberIndex}" v-for="(item,index) in memberTabsData" :key="index" @click.native="memberTabs(index)">
              <el-row class="inRow">
                <img :src="item.img" alt="">
                <span>{{item.text}}</span>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="memberContent">
            <template v-if="memberIndex==0">
              <template v-if="roleType==2">
                <h3>
                  会籍信息
                </h3>
                <el-divider></el-divider>
              </template>
              <MembershipInfo :userInfoData='userInfoData' ref="membershipInfo" />
            </template>
            <template v-if="memberIndex==1">
              <h3>
                缴费记录<span class="required-tips" v-if="roleType == 3">（必填）</span>
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(1)">
              </h3>
              <el-divider></el-divider>
              <Payment />
            </template>
            <template v-if="memberIndex==2">
              <h3>
                发票信息<span class="required-tips" v-if="roleType == 3">（必填）</span>
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(2)">
              </h3>
              <el-divider></el-divider>
              <el-row class="editInvoice" v-if="roleType==3">
                <el-button class="editFile" :disabled="isEditInv" :class="{edit:isInvEdit1}" @click="editInvoice">编辑</el-button>
                <el-button class="editFile" :disabled="isSaveInv" :class="{edit:isInvEdit2}" @click="saveInvoice">保存</el-button>
                <el-button class="editFile" :disabled="isCancelInv" :class="{edit:isInvEdit3}" @click="cancelInvoice">取消</el-button>
              </el-row>
              <el-form ref="invoiceFormRef" :label-position="labelPosition" :model="invoiceFormData" :rules="invoiceFormRules" label-width="140px" class="invoiceFormData" :disabled="isShowInvoice">
                <el-row>
                  <template v-if="isInvEdit1">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="纳税人名称:">
                        <span>{{invoiceFormData.taxpayerName}}</span>
                      </el-form-item>
                      <el-form-item label="开户行名称:">
                        <span>{{invoiceFormData.bankName}}</span>
                      </el-form-item>
                      <el-form-item label="开户行地址:">
                        <span>{{invoiceFormData.bankAddress}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="纳税人税号:">
                        <span>{{invoiceFormData.taxpayerNo}}</span>
                      </el-form-item>
                      <el-form-item label="开户行账号:">
                        <span>{{invoiceFormData.bankAccount}}</span>
                      </el-form-item>
                      <el-form-item label="电 话:">
                        <span>{{invoiceFormData.phone}}</span>
                      </el-form-item>
                    </el-col>
                  </template>
                  <template v-if="isInvEdit1==false&&roleType==3">
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="纳税人名称:" prop="taxpayerName">
                        <el-input v-model="invoiceFormData.taxpayerName"></el-input>
                      </el-form-item>
                      <el-form-item label="开户行名称:" prop="bankName">
                        <el-input v-model="invoiceFormData.bankName"></el-input>
                      </el-form-item>
                      <el-form-item label="开户行地址:" prop="bankAddress">
                        <el-input v-model="invoiceFormData.bankAddress"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="纳税人税号:" prop="taxpayerNo">
                        <el-input v-model="invoiceFormData.taxpayerNo"></el-input>
                      </el-form-item>
                      <el-form-item label="开户行账号:" prop="bankAccount">
                        <el-input v-model="invoiceFormData.bankAccount"></el-input>
                      </el-form-item>
                      <el-form-item label="电 话:" prop="phone">
                        <el-input v-model="invoiceFormData.phone"></el-input>
                      </el-form-item>
                    </el-col>
                  </template>
                </el-row>
              </el-form>
            </template>
            <template v-if="memberIndex==3">
              <h3>
                联系人信息<span class="required-tips" v-if="roleType == 3">（必填）</span>
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(3)">
              </h3>
              <el-divider></el-divider>
              <Contact />
            </template>
            <template v-if="memberIndex==4">
              <h3>财务状况</h3>
              <el-divider></el-divider>
              <el-row class="assetsOne">资产负债</el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">年份</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.year}}年</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">资产总计（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.totalAssetsAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">税前利润（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.preTaxProfitsAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">负债合计（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.totalLiabilitiesAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">营业收入（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.operatingIncome}}</el-col>
              </el-row>
              <el-row class="assetsOne">损益及分配</el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">信用调查与服务业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditInvestigationServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">公共信用管理服务业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.publicCreditManagementServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">信用评价业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditRatingServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">信用担保业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditGuaranteeBusinessAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">保理业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.commercialFactoringAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">信用保险服务业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditInsuranceServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">商账管理服务业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.businessAccountManagementServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">大数据信用服务金额（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">信用管理咨询业务（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.creditManagementServiceAmount}}</el-col>
              </el-row>
              <el-row class="assets">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">其他业务收入（单位：千元）</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.otherBusinessAmount}}</el-col>
              </el-row>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">其他业务内容描述说明</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="changeColor textCenter" v-for="(item,index) in assetsData" :key="index">{{item.otherBusinessContentDescription}}</el-col>
              </el-row>

            </template>
            <template v-if="memberIndex==5">
              <h3>业务情况</h3>
              <el-divider></el-divider>
              <el-row class="assets addBgc">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="addColor">年份</el-col>
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter title" v-for="(item,index) in busData" :key="index">{{item.year==null?'':(item.year+'年')}}</el-col>
              </el-row>
              <!-- 基础信息服务 -->
              <template v-if="one==1">
                <el-row class="assetsOne">信用调查与服务</el-row>
                <el-row class="titleTwo">企业信用服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">信用报告出具数（单位：份）</div>
                    <div class="titleThree title">其他征信服务产品提供次数（单位：份）</div>
                    <div class="titleThree title">客户数量（单位：家）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.companyCreditReportNumber}}</div>
                    <div class="titleThree">{{item.companyOtherCreditProductNumber}}</div>
                    <div class="titleThree">{{item.companyCustomerNumber}}</div>
                  </el-col>
                </el-row>
                <el-row class="titleTwo">个人信用服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">信用报告出具数（单位：份）</div>
                    <div class="titleThree title">客户数量（单位：家）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.personalCreditReportNumber}}</div>
                    <div class="titleThree">{{item.personalCustomerNumber}}</div>
                  </el-col>
                </el-row>
              </template>

              <template v-if="two==1">
                <el-row class="assetsOne">公共信用管理服务</el-row>
                <el-row class="titleTwo">社会信用管理服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务政府项目数（单位：次）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.socialGovernmentProjectNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">行业信用管理服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务行业协会项目数（单位：次）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.industryServiceIndustryNumber}}
                  </el-col>
                </el-row>
              </template>
              <!-- 增值信用服务 -->
              <template v-if="three==1">
                <el-row class="assetsOne">信用评价</el-row>
                <el-row class="titleTwo">工商企业信用评价服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    评价数量
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.industryRatingNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">金融机构信用评价服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    评价数量
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.financialRatingNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">结构融资评价</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    评价数量
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.structuredRatingNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">公共融资信用评价服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    评价数量
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.publicRatingNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">主权信用评价服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    评价数量
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.sovereignRatingNumber}}
                  </el-col>
                </el-row>
              </template>

              <template v-if="four==1">
                <el-row class="assetsOne">信用担保</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">担保数量（单位：笔）</div>
                    <div class="titleThree title">担保合计金额（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.guaranteeNumber}}</div>
                    <div class="titleThree">{{item.totalGuaranteeAmount}}</div>
                  </el-col>
                </el-row>
              </template>

              <template v-if="five==1">
                <el-row class="assetsOne">保理</el-row>
                <el-row class="titleTwo">银行保理</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">保理业务发生笔数（单位：笔）</div>
                    <div class="titleThree title">保理业务发生额（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.bankFactoringNumber}}</div>
                    <div class="titleThree">{{item.bankFactoringIncurredAmount}}</div>
                  </el-col>
                </el-row>
                <el-row class="titleTwo">商业保理</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">保理业务发生笔数（单位：笔）</div>
                    <div class="titleThree title">保理业务发生额（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.commercialFactoringNumber}}</div>
                    <div class="titleThree">{{item.commercialFactoringIncurredAmount}}</div>
                  </el-col>
                </el-row>

              </template>

              <template v-if="six==1">
                <el-row class="assetsOne">信用保险服务</el-row>
                <el-row class="titleTwo">商业信用保险服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">保单数（单位：笔）</div>
                    <div class="titleThree title">承保金额合计（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.commercialPoliciesNumber}}</div>
                    <div class="titleThree">{{item.commercialTotalInsuredAmount}}</div>
                  </el-col>
                </el-row>
                <el-row class="titleTwo">出口信用保险服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">保单数（单位：笔）</div>
                    <div class="titleThree title">承保金额合计（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.exportPoliciesNumber}}</div>
                    <div class="titleThree">{{item.exportTotalInsuredAmount}}</div>
                  </el-col>
                </el-row>
              </template>

              <template v-if="seven==1">
                <el-row class="assetsOne">商账管理服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">应收账委托金额合计（单位：千元）</div>
                    <div class="titleThree title">应收账款回收金额合计（单位：千元）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.totalEntrustmentAmount}}</div>
                    <div class="titleThree">{{item.totalReceivablesAmount}}</div>
                  </el-col>
                </el-row>
              </template>
              <!-- 衍生信用服务 -->
              <template v-if="eight==1">
                <el-row class="assetsOne">大数据信用信息服务</el-row>
                <el-row class="titleTwo">信用信息整理与清洗</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务客户数（单位：家）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.creditCleaningCustomerNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">信用信息挖掘与分析</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务客户数（单位：家）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.creditAnalysisCustomerNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">互联网金融信息服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务客户数（单位：家）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.internetServiceCustomerNumber}}
                  </el-col>
                </el-row>
              </template>

              <template v-if="nine==1">
                <el-row class="assetsOne">信用管理咨询</el-row>
                <el-row class="titleTwo">信用信息场景应用</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务客户数（单位：家）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.creditApplicationCustomerNumber}}
                  </el-col>
                </el-row>
                <el-row class="titleTwo">信用预警</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">当年被预警监测企业数（单位：家）</div>
                    <div class="titleThree title">当年预警服务的客户数（单位：家）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.creditMonitoredWarningNumber}}</div>
                    <div class="titleThree">{{item.creditCustomerWarningNumber}}</div>
                  </el-col>
                </el-row>
                <el-row class="titleTwo">信用培训服务</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                    <div class="titleThree title">培训场次（单位：家）</div>
                    <div class="titleThree title">培训人次合计（单位：人次）</div>
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter" v-for="(item,index) in busData" :key="index">
                    <div class="titleThree">{{item.creditTrainingSession}}</div>
                    <div class="titleThree">{{item.creditTotalTrainingPerson}}</div>
                  </el-col>
                </el-row>
                <el-row class="titleTwo">信用信息安全管理</el-row>
                <el-row>
                  <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="titleThree title">
                    服务客户数（单位：家）
                  </el-col>
                  <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="addColor textCenter titleThree" v-for="(item,index) in busData" :key="index">
                    {{item.creditManagementCustomerNumber}}
                  </el-col>
                </el-row>
              </template>
            </template>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="公司信息" name="2" class="companyInfomation">
          <template v-if="roleType==2">
            <div class="arrow leftArrow" :style="{display:isLeftBlock}" @click="moveLeftTab">
              <img src="@/assets/img/左箭头.png" alt="">
            </div>
            <div class="arrow rightArrow" :style="{display:isRightBlock}" @click="moveRightTab">
              <img src="@/assets/img/右箭头.png" alt="">
            </div>
          </template>
          <!-- 信管页面 -->
          <el-row class="memberTabs adminTabs" :class="{isAnimationLeft:isAnimationLeft,isAnimationRight:isAnimationRight}" v-if=" roleType==2">
            <el-col class="memberCol companyCol" :class="{activeStyle:index==companyIndex,pointerEvent:index==9}" v-for="(item,index) in adminTabsData" :key="index" @click.native="companyTabs(index)">
              <el-row class="inRow">
                <img :src="item.img" alt="">
                <span>{{item.text}}</span>
              </el-row>
            </el-col>
          </el-row>
          <!-- 会员页面 -->
          <el-row class="memberTabs memberRow" v-if="roleType==3">
            <el-col class="memberCol companyCol" :class="{activeStyle:index==companyIndex}" v-for="(item,index) in companyTabsData" :key="index" @click.native="companyTabs(index)" style="width:20%">
              <el-row class="inRow">
                <img :src="item.img" alt="">
                <span>{{item.text}}</span>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="memberContent">
            <!-- 基本信息 -->
            <template v-if="companyIndex==0">
              <h3>
                基本信息<span class="required-tips" v-if="roleType == 3">（必填）</span>
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(4)">
              </h3>
              <el-divider></el-divider>
              <el-row class="editInvoice" v-if="roleType==3">
                <el-button class="editFile" :disabled="isEditCom" :class="{edit:isComEdit1}" @click="editCompanyInfo">编辑</el-button>
                <el-button class="editFile" :disabled="isSaveCom" :class="{edit:isComEdit2}" @click="saveCompanyInfo">保存</el-button>
                <el-button class="editFile" :disabled="isCancelCom" :class="{edit:isComEdit3}" @click="cancelCompanyInfo">取消</el-button>
              </el-row>
              <el-form :model="infoFormData" :rules="infoFormRules" ref="infoFormRef" label-width="160px" class="infoFormData" :disabled="isAdd">
                <template v-if="roleType==3&&isComEdit1==false">
                  <el-row>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="网站" prop="website">
                        <el-input v-model="infoFormData.website"></el-input>
                      </el-form-item>
                      <el-form-item label="传真" prop="fax">
                        <el-input v-model="infoFormData.fax"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="邮箱" prop="email">
                        <el-input v-model="infoFormData.email"></el-input>
                      </el-form-item>
                      <el-form-item label="员工总数" prop="employeeNumber">
                        <el-input v-model="infoFormData.employeeNumber"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="公司简介" prop="companyProfile">
                    <el-input type="textarea" v-model="infoFormData.companyProfile"></el-input>
                  </el-form-item>
                  <el-form-item label="高管简介" prop="executiveSummary">
                    <el-input type="textarea" v-model="infoFormData.executiveSummary"></el-input>
                  </el-form-item>
                </template>
                <template v-if="roleType==3&&isComEdit1">

                  <el-row>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="网站">
                        <span class="companyInfo">{{infoFormData.website}}</span>
                      </el-form-item>
                      <el-form-item label="传真">
                        <span class="companyInfo">{{infoFormData.fax}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="邮箱">
                        <span class="companyInfo">{{infoFormData.email}}</span>
                      </el-form-item>
                      <el-form-item label="员工总数">
                        <span class="companyInfo">{{infoFormData.employeeNumber}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="公司简介" prop="companyProfile">
                    <span class="companyInfo">{{infoFormData.companyProfile}}</span>
                  </el-form-item>
                  <el-form-item label="高管简介" prop="executiveSummary">
                    <span class="companyInfo">{{infoFormData.executiveSummary}}</span>
                  </el-form-item>
                </template>
                <template v-if="roleType==2">
                  <el-row>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="统一征信代码">
                        <span class="companyInfo">{{infoFormData.uniformCreditCode==null?($route.query.id=='6327464065b269a868e558366cd2022c'?'91310110MA1G8LJG6T':''):infoFormData.uniformCreditCode}}</span>
                      </el-form-item>
                      <el-form-item label="邮箱">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.email}}</span>
                      </el-form-item>
                      <el-form-item label="行业">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.industry}}</span>
                      </el-form-item>
                      <el-form-item label="公司注册地址行政编号">
                        <span class="companyInfo">{{infoFormData.companyRegisteredAddress==null?($route.query.id=='6327464065b269a868e558366cd2022c'?'310000':''):infoFormData.companyRegisteredAddress}}</span>
                      </el-form-item>
                      <el-form-item label="员工总数">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.employeeNumber}}</span>
                      </el-form-item>
                      <el-form-item label="法人代表">
                        <span class="companyInfo">{{infoFormData.legalRepresentative==null?($route.query.id=='6327464065b269a868e558366cd2022c'?'姚翔':''):infoFormData.legalRepresentative}}</span>
                      </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                      <el-form-item label="网站">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.website}}</span>
                      </el-form-item>
                      <el-form-item label="传真">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.fax}}</span>
                      </el-form-item>
                      <el-form-item label="公司注册资本">
                        <span class="companyInfo">{{infoFormData.registeredCapital==null?($route.query.id=='6327464065b269a868e558366cd2022c'?'500.00万人民币':''):infoFormData.registeredCapital}}</span>
                      </el-form-item>
                      <!-- <el-form-item label="业务活动类型">
                        <span class="companyInfo">{{businessType}}</span>
                      </el-form-item> -->
                      <el-form-item label="经营期限">
                        <span class="companyInfo">{{infoFormData==null?'':infoFormData.businessPeriod}}</span>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="单位经营地址">
                    <span class="companyInfo">{{infoFormData.actualBusinessAddress==null?($route.query.id=='6327464065b269a868e558366cd2022c'?'上海市杨浦区隆昌路588号3号楼308室':''):infoFormData.actualBusinessAddress}}</span>
                  </el-form-item>
                  <el-form-item label="公司简介" prop="companyProfile">
                    <span class="companyInfo">{{infoFormData==null?'':infoFormData.companyProfile}}</span>
                  </el-form-item>
                  <el-form-item label="高管简介" prop="executiveSummary">
                    <span class="companyInfo">{{infoFormData==null?'':infoFormData.executiveSummary}}</span>
                  </el-form-item>
                </template>
              </el-form>
            </template>
            <!-- 文件管理 -->
            <template v-if="companyIndex==1">
              <FileManagement ref="FileManagement" />
            </template>
            <!-- 高管资质 -->
            <template v-if="companyIndex==2">
              <h3>
                高管资质
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(6)">
              </h3>
              <el-divider></el-divider>
              <el-row class="addContact" v-if="roleType==3" @click.native="addQua">
                <i class="el-icon-plus"> 添加高管资质</i>
              </el-row>
              <el-table :data="quaTableData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="executiveQualificationName" label="名称">
                </el-table-column>
                <el-table-column prop="fileName" label="文件">
                  <template slot-scope="scope">
                    <el-link class="downLoad" @click="downLoadQua(scope.row.fileName,scope.row.file)" :download="scope.row.fileName">{{scope.row.fileName}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="getTime" label="获得时间">
                  <template slot-scope="scope">
                    {{scope.row.getTime.substr(0,10)}}
                  </template>
                </el-table-column>
                <el-table-column label="操作" v-if="roleType==3">
                  <template slot-scope="scope">
                    <span class="downLoad" @click="editQua(scope.row)">修改</span>
                    <span class="downLoad delete" @click="deleteQua(scope.row.id)">删 除</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination @current-change="handleQuaChange" :current-page.sync="quaParams.pageNumber" :page-size="quaParams.pageSize" layout="total, prev, pager, next" :total="quaTotal">
              </el-pagination>
            </template>
            <!-- 资质及补贴信息、荣誉信息 -->
            <template v-if="companyIndex==3">
              <h3>
                资质及补贴信息、荣誉信息
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(7)">
              </h3>
              <el-divider></el-divider>
              <HonorInfo />
            </template>
            <!-- 高管及其他任职信息 -->
            <template v-if="companyIndex==4">
              <h3>
                高管及其他任职信息
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(10)">
              </h3>
              <el-divider></el-divider>
              <Executive />
            </template>
            <template v-if="roleType==2&&companyIndex==5">
              <h3>
                司法判决信息
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(9)">
              </h3>
              <el-divider></el-divider>
              <h4 class="negFactStyle">裁判文书</h4>
              <el-table :data="negFactData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="fileNumber" label="案号">
                </el-table-column>
                <el-table-column prop="role" label="角色">
                </el-table-column>
                <el-table-column prop="publishDate" label="发布日期">
                </el-table-column>
                <el-table-column prop="judgeresult" label="审判结果">
                </el-table-column>
              </el-table>
              <h4 class="negFactStyle">失信人执行公告</h4>
              <el-table :data="negFactData1" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="defendantCN" label="当事人名称">
                </el-table-column>
                <el-table-column prop=" deLegelName" label="当事人法人代表姓名">
                </el-table-column>
                <el-table-column prop="provinceCN" label="省份">
                </el-table-column>
                <el-table-column prop="enforcementBasisNumber" label="执行依据文号">
                </el-table-column>
                <el-table-column prop="judgeresult" label="审判结果">
                </el-table-column>
              </el-table>
              <h4 class="negFactStyle">被执行人公告</h4>
              <el-table :data="negFactData2" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="name" label="公司名称">
                </el-table-column>
                <el-table-column prop="occurrenceDate" label="立案时间">
                </el-table-column>
                <el-table-column prop="fileNumber" label="案号">
                </el-table-column>
                <el-table-column prop="subjectAmount" label="执行标的">
                </el-table-column>
                <el-table-column prop="courtNameCN" label="执行法院">
                </el-table-column>
              </el-table>
            </template>
            <template v-if="roleType==2&&companyIndex==6">
              <h3>
                知识产权
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(8)">
              </h3>
              <el-divider></el-divider>
              <h4 class="negFactStyle">商标信息</h4>
              <el-table :data="brandData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="imageUrl" label="商标图片">
                </el-table-column>
                <el-table-column prop="brandNameCN" label="商标名称">
                </el-table-column>
                <el-table-column prop="applicantStatusCN" label="商标状态">
                </el-table-column>
                <el-table-column prop="applyDate" label="申请日期">
                </el-table-column>
                <el-table-column prop="brandRegisterNo" label="注册号">
                </el-table-column>
                <el-table-column prop="brandTypeNo" label="商标类别">
                </el-table-column>
              </el-table>
              <h4 class="negFactStyle">著作权</h4>
              <el-table :data="copyRightData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="crNameCN" label="著作名称">
                </el-table-column>
                <el-table-column prop="crRegisterNoCN" label="登记号">
                </el-table-column>
                <el-table-column prop="crTypeCN" label="类别">
                </el-table-column>
                <el-table-column prop="crPersonCN" label="著作权人">
                </el-table-column>
                <el-table-column prop="brandRegisterNo" label="著作权人类型">
                </el-table-column>
                <el-table-column prop="crRegisterDate" label="登记日期">
                </el-table-column>
              </el-table>
            </template>
            <!-- 下面两个没接数据 -->
            <template v-if="roleType==2&&companyIndex==7">
              <h3>
                股东信息
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(11)">
              </h3>
              <el-divider></el-divider>
              <el-table :data="partnerData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="SHAREHOLDER_NAME" label="股东姓名">
                </el-table-column>
                <el-table-column prop="SUBSCRIBE_AMOUNT" label="认缴出资额">
                </el-table-column>
                <el-table-column prop="SUBSCRIBE_TIME" label="认缴出资时间">
                </el-table-column>
                <el-table-column prop="SUBSCRIBE_TYPE" label="认缴出资方式">
                </el-table-column>
                <el-table-column prop="PAID_AMOUNT" label="实缴出资额">
                </el-table-column>
                <el-table-column prop="PAID_TIME" label="实缴出资时间">
                </el-table-column>
                <el-table-column prop="PAID_TYPE" label="实缴出资方式">
                </el-table-column>
              </el-table>
            </template>
            <template v-if="roleType==2&&companyIndex==8">
              <h3>
                企业对外投资
                <img v-if="roleType==2" class="adminEdit" src="@/assets/img/编辑.png" alt="" @click="findRemark(12)">
              </h3>
              <el-divider></el-divider>
              <el-table :data="internationalData" stripe style="width: 100%" class="infoTableData">
                <el-table-column prop="INVEST_COMPANY_NAME" label="对外投资企业名称">
                </el-table-column>
                <el-table-column prop="REG_NUM" label="注册号">
                </el-table-column>
                <el-table-column prop="USC_CODE" label="统一社会">
                </el-table-column>
                <el-table-column prop="REMARKS" label="说明">
                </el-table-column>
                <el-table-column prop="INVESTDATE" label="对外投资时间">
                </el-table-column>
                <el-table-column prop="CAPITAL" label="认缴金额">
                  <template slot-scope="scope">
                    {{scope.row.CAPITAL==null||scope.row.CAPITAL=='[]'?"":scope.row.CAPITAL[0].amomon}}
                  </template>
                </el-table-column>
                <el-table-column prop="CAPITALACTL" label="实缴金额">
                  <template slot-scope="scope">
                    {{scope.row.CAPITALACTL==null||scope.row.CAPITALACTL=='[]'?"":(scope.row.CAPITALACTL[0].amomon=='null'?'':scope.row.CAPITALACTL[0].amomon)}}
                  </template>
                </el-table-column>
                <el-table-column prop="AMOUNT" label="投资金额">
                </el-table-column>
              </el-table>
            </template>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="企业产品" name="3" class="companyProduct" v-if="roleType==2">
          <div class="delete">
            <img src="@/assets/img/productDel.jpg" alt="">
            <!-- <p>系统升级中</p> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="调查表查看" name="4" v-if="roleType==2">
          <template v-if="roleType==2 && $route.name=='Management' && activeName=='4'">
            <Questionnaire ref="adminQuse" :yearData="yearData" />
          </template>
        </el-tab-pane>
        <el-tab-pane label=" 企业拜访记录" name="5" class="busVisitRecord" v-if="roleType==2">
          <div class="delete">
            <img src="@/assets/img/productDel.jpg" alt="">
            <!-- <img src="@/assets/img/火箭.png" alt="">
            <p>系统升级中</p> -->
          </div>
        </el-tab-pane>
      </el-tabs>
      <div class="questionnaire noticeMember" v-if="roleType==2" @click="tabIndex=2">通知会员</div>
      <div class="questionnaire" v-if="roleType==2" @click="monitorClick">监控管理</div>
      <div class="questionnaire" v-if="roleType==3" @click="tabIndex = 1">调查表填写</div>
      <!-- 添加高管资质 -->
      <el-dialog :title="isQua==1 ? '添加高管资质':'修改高管资质'" :visible.sync="addQuaVisible" width="35%" custom-class="addInfoVisible addQuaVisible" @close="closeQuaDialog" @open="openQuaDialog">
        <el-form :model="addQuaForm" :rules="addQuaRules" ref="addQuaFormRef" label-width="130px" class="demo-ruleForm">
          <el-form-item label="名称" prop="executiveQualificationName">
            <el-input v-model="addQuaForm.executiveQualificationName"></el-input>
          </el-form-item>
          <el-form-item label="获得时间" prop="getTimeStr">
            <el-date-picker v-model="addQuaForm.getTimeStr" type="date" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="文件" prop="file">
            <el-upload class="upload-demo" :headers="headerObj" :action="uploadUrl" :on-success="quaSuccess" :on-remove="removeQua" :before-upload="beforeAvatarUpload" :file-list="quaFileList" :key="4" style="float:left;">
              <span class="uploaadImg"><img src="@/assets/img/上传.png" alt="">点击上传</span>
              <!-- <span slot="tip" class="el-upload__tip" :style="{color:activeColor}">{{message}}</span> -->
            </el-upload>
            <el-link class="el-upload__tip linkStyle example" :href="`${publicPath}file/企业负责人信用报告.png`" download="企业负责人信用报告.png" style="height:22px;float:left;">样例下载</el-link>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <span class="button add" type="primary" @click="addQuaList">{{isQua==1?'新 增':'修 改'}}</span>
          <span class="button" @click="addQuaVisible = false">取 消</span>

          <div><br>高管的资质说明：即各类职业资质，例如：高级经济师，注册会计师，律师，等</div>
        </span>

      </el-dialog>
      <!-- 监控管理平台对话框 -->
      <MonitorDialog />
      <!-- 管理员备注 -->
      <el-dialog :title="remarkTitle+'备注'" :visible.sync="remarkVisible" width="30%" custom-class="remarkVisible" @close="closeRemark">
        <el-row class="addRemark">
          <span @click="addRemarkVisible = true">
            <img src="@/assets/img/编辑.png" alt=""> 添加备注
          </span>
        </el-row>
        <el-table :data="remarkData" stripe style="width: 100%;" class="remarkData">
          <el-table-column label="管理员" prop="remarkName"> </el-table-column>
          <el-table-column label="填写时间" prop="remarkTime"> </el-table-column>
          <el-table-column label="内容" prop="remarkContent"> </el-table-column>
        </el-table>
        <el-pagination @current-change="remarkCurrent" :current-page.sync="remarkParams.pageNumber" :page-size="remarkParams.pageSize" layout="total, prev, pager, next" :total="remarkTotal">
        </el-pagination>
      </el-dialog>
      <!-- 管理员添加备注 -->
      <el-dialog :title="`添加${remarkTitle}备注`" :visible.sync="addRemarkVisible" width="30%" custom-class="addRemarkVisible" @close="closeRemarkDialog">
        <el-form :model="remarkForm" :rules="remarkFormRules" ref="remarkForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="备注" prop="adminRemark">
            <el-input type="textarea" v-model="remarkForm.adminRemark" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <span class="button add" type="primary" @click="sureRemark">确 定</span>
          <span class="button" @click="addRemarkVisible = false">取 消</span>
        </span>
      </el-dialog>

    </template>
    <template v-else-if="tabIndex==1&&roleType==3">
      <Questionnaire :yearData="yearData" />
    </template>
    <!-- 通知会员 -->
    <template v-if="tabIndex==2">
      <NoteDialog :contentRequired="true" />
    </template>
  </div>
</template>
<script>
import Questionnaire from '../../common/Questionnaire.vue'
import HonorInfo from '../../common/HonorInfo.vue'
import Contact from '../../common/Contact.vue'
import Payment from '../../common/Payment.vue'
import Executive from '../../common/Executive.vue'
import MonitorDialog from '../../common/MonitorDialog.vue'
import NoteDialog from '../../common/NoteDialog.vue'
import FileManagement from '../../common/FileManagement.vue'
import MembershipInfo from '../../common/MembershipInfo.vue'
import { findInvoiceInfo, addInvoiceInfo, findCompanyInfo, addCompanyInfo, findProBusType, findQuaInfo, addQuaInfo, delQuaInfo, findSurveyYear, findNegFact, findNegFact1, findNegFact2, findBrand, findCopyRight, findFinancialInformation, findBusinessInformation, findRemarkList, addRemark, userMemberInfo, moduleInformation } from '@/api/index'
import { downLoadFiles, emailTest } from '@/assets/js/common'
export default {
  data() {
    var validateEmail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入邮箱'));
      } else if (!emailTest(value)) {
        callback(new Error('请输入包含@的合法邮箱!'));
      } else {
        callback();
      }
    };
    return {
      name: 'management',
      publicPath: process.env.BASE_URL,  //模板路径
      yearList: [],
      yearData: [],
      activeName: '1', // 1会员档案页面 2公司信息页面
      userId: sessionStorage.getItem('userId'),
      roleType: window.sessionStorage.getItem('roleType'),
      tabIndex: 0,  //0会员信息页面 1调查表页面
      // memberProfile
      // activeNames1: ['1'],
      userInfoData: {
        userId: "",
        initiationTime: '',
        memberGrade: ''
      },
      addContectVisible: false,
      telTableData: [],
      telFlag: 1,
      addTelForm: {
        id: '',
        contactStatus: 1,
        contactName: '',
        position: '',
        fixedTelephone: '',
        mobilePhone: '',
        email: '',
        comment: '',
        switchValue: false,
      },
      addTelFormRules: {
        switchValue: [
          { required: true, message: '请输入职称', trigger: 'blur' },
        ],
        contactName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        position: [
          { required: true, message: '请输入职位', trigger: 'blur' },
        ],
        fixedTelephone: [
          { required: true, message: '请输入固定电话', trigger: 'blur' },
        ],
        mobilePhone: [
          { required: true, message: '请输入移动电话', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
        ],
      },
      labelPosition: 'left',
      // 发票信息
      invoiceFormData: {
        id: '',
        taxpayerName: "",
        taxpayerNo: "",
        bankName: "",
        bankAccount: "",
        bankAddress: "",
        phone: ""
      },
      invoiceFormRules: {
        taxpayerName: [
          { required: true, message: '请输入纳税人名称', trigger: 'blur' }
        ],
        taxpayerNo: [
          { required: true, message: '请输入纳税人税号', trigger: 'blur' },
        ],
        bankName: [
          { required: true, message: '请输入开户行名称', trigger: 'blur' },
        ],
        bankAccount: [
          { required: true, message: '请输入开户行账号', trigger: 'blur' },
        ],
        bankAddress: [
          { required: true, message: '请输入开户行地址', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' },
        ]
      },
      isShowInvoice: false,
      isInvEdit1: false,
      isInvEdit2: true,
      isInvEdit3: false,
      isEditInv: true,
      isSaveInv: false,
      isCancelInv: false,
      // companyInfomation
      activeNames2: ['1'],
      isAdd: false,
      isComEdit1: false,
      isComEdit2: true,
      isComEdit3: false,
      isEditCom: true,
      isSaveCom: false,
      isCancelCom: false,
      busOptions: [],
      infoFormData: {
        id: '',
        uniformCreditCode: '',
        website: '',
        email: '',
        fax: '',
        industryName: '',
        businessTypeId: '',
        registeredCapital: '',
        companyRegisteredAddress: '',
        actualBusinessAddress: "",
        businessPeriod: '',
        legalRepresentative: '',
        companyProfile: '',
        executiveSummary: '',
        businessAddress: "",
        employeeNumber: "",
      },
      infoFormRules: {
        website: [{ required: true, message: '请输入网站', trigger: 'blur' }],
        email: [{ required: true, validator: validateEmail, trigger: 'blur' }],
        fax: [{ required: true, message: '请输入传真', trigger: 'blur' }],
        employeeNumber: [{ required: true, message: '请输入员工总数', trigger: 'blur' }],
      },
      headerObj: { token: window.sessionStorage.getItem('token') },
      uploadUrl: '', // 单文件
      uploadUrls: '', // 多文件
      quaTableData: [],
      quaParams: {
        pageNumber: 1,
        pageSize: 5,
        userId: ''
      },
      quaTotal: 0,
      isQua: 1,
      addQuaVisible: false,
      quaFileList: [],
      addQuaForm: {
        id: '',
        executiveQualificationName: '',
        getTimeStr: '',
        file: '',
        fileName: ''
      },
      addQuaRules: {
        executiveQualificationName: [
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        getTimeStr: [
          { required: true, message: '请输入时间', trigger: 'blur' },
        ],
      },
      brandData: [],
      copyRightData: [],
      negFactData: [],
      negFactData1: [],
      negFactData2: [],
      //会员档案tab栏
      memberIndex: 0,
      memberTabsData: [
        {
          id: 0,
          img: require('@/assets/img/会籍信息.png'),
          text: '会籍信息'
        },
        {
          id: 1,
          img: require('@/assets/img/pay.png'),
          text: '缴费记录'
        },
        {
          id: 2,
          img: require('@/assets/img/invoice.png'),
          text: '发票信息'
        },
        {
          id: 3,
          img: require('@/assets/img/contact.png'),
          text: '联系人信息'
        },
        {
          id: 4,
          img: require('@/assets/img/money.png'),
          text: '财务状况'
        },
        {
          id: 5,
          img: require('@/assets/img/product.png'),
          text: '业务情况'
        },
      ],
      // 公司信息tab栏
      companyIndex: 0,
      companyTabsData: [
        {
          id: 0,
          img: require('@/assets/img/basicInfo.png'),
          text: '基本信息'
        },
        {
          id: 1,
          img: require('@/assets/img/file.png'),
          text: '文件管理'
        },
        {
          id: 2,
          img: require('@/assets/img/qualification.png'),
          text: '高管资质'
        },
        {
          id: 3,
          img: require('@/assets/img/honor.png'),
          text: '资质及补贴信息、荣誉信息'
        },
        {
          id: 4,
          img: require('@/assets/img/高管及其他.png'),
          text: '高管及其任职信息'
        }
      ],
      adminTabsData: [
        {
          id: 0,
          img: require('@/assets/img/basicInfo.png'),
          text: '基本信息'
        },
        {
          id: 1,
          img: require('@/assets/img/file.png'),
          text: '文件管理'
        },
        {
          id: 2,
          img: require('@/assets/img/qualification.png'),
          text: '高管资质'
        },
        {
          id: 3,
          img: require('@/assets/img/honor.png'),
          text: '资质及补贴信息、荣誉信息'
        },
        {
          id: 4,
          img: require('@/assets/img/高管及其他.png'),
          text: '高管及其任职信息'
        },
        {
          id: 5,
          img: require('@/assets/img/judge.png'),
          text: '司法判决信息'
        },
        {
          id: 6,
          img: require('@/assets/img/knowledge.png'),
          text: '知识产权'
        },
        {
          id: 7,
          img: require('@/assets/img/股东.png'),
          text: '股东信息'
        },
        {
          id: 8,
          img: require('@/assets/img/企业.png'),
          text: '企业对外投资'
        },
        {
          id: 9,
          img: '',
          text: ''
        }
      ],
      isAnimationLeft: false,   //是否开启左箭头动画
      isAnimationRight: false,   //是否开启右箭头动画
      isLeftBlock: 'block',   // 左箭头是否隐藏
      isRightBlock: 'none',   // 右箭头是否隐藏
      managementData: [],   // 高管及其他任职信息
      partnerData: [],   // 股东信息
      internationalData: [],   // 企业对外投资
      assetsData: [],//财务情况数据
      busData: [],//业务状况数据
      one: 0,//调查表业务类型
      two: 0,//调查表业务类型
      three: 0,//调查表业务类型
      four: 0,//调查表业务类型
      five: 0,//调查表业务类型
      six: 0,//调查表业务类型
      seven: 0,//调查表业务类型
      eight: 0,//调查表业务类型
      nine: 0,//调查表业务类型
      // businessType: [],//公司信息业务活动类型
      businessAddress: [],//公司信息单位经营地址
      // 管理员备注
      remarkTitle: '',
      remarkVisible: false,
      remarkData: [],
      remarkType: 0,
      remarkTotal: 0,
      remarkParams: {
        userId: '',
        remarkType: 0,
        pageNumber: 1,
        pageSize: 4,
      },
      // 管理员添加备注
      addRemarkVisible: false,
      remarkForm: {
        adminRemark: "",
        remarkType: 0,
        createUserId: ''
      },
      remarkFormRules: {
        adminRemark: [
          { required: true, message: '请输入备注内容', trigger: 'blur' }
        ]
      },
      isShowMonitor: false,
    }
  },
  created() {
    this.uploadUrl = this.$http.defaults.baseURL + 'user/uploadFile'
    this.uploadUrls = this.$http.defaults.baseURL + 'user/uploadFiles'
    this.findUserMember()
    this.initData()
    this.init()
    // 调查表管理中的公司点击进入后，展示--联系人信息
    if (this.$route.query.memberIndex) {
      this.memberIndex = this.$route.query.memberIndex
    }
  },
  methods: {

    init() {
      if (this.roleType == 2 && this.$route.query.remindType == 5) {
        this.activeName = '4'
      }
      if (this.roleType == 3 && this.$route.query.type == 3) {
        this.activeName = '2'
      }
      if (this.roleType == 3 && this.$route.query.type == 4) {
        this.memberIndex = 1
      }

    },

    //点击通知会员
    noticeClick() {
      this.$children[6].addNoticeVisible = true
    },
    // 点击监控管理
    monitorClick() {
      this.$children[3].monitorVisible = true
      this.isShowMonitor = true
    },
    /**
     *管理员备注
     */
    // 查看备注
    async findRemark(type) {
      this.remarkVisible = true
      this.remarkType = type
      this.remarkParams.remarkType = type
      this.remarkForm.remarkType = type
      this.remarkParams.userId = this.$route.query.id
      this.remarkForm.createUserId = this.$route.query.id
      if (type == 1) {
        this.remarkTitle = '缴费记录'
      } else if (type == 2) {
        this.remarkTitle = '发票信息'
      } else if (type == 3) {
        this.remarkTitle = '联系人信息'
      } else if (type == 4) {
        this.remarkTitle = '基本信息'
      } else if (type == 5) {
        this.remarkTitle = '文件管理'
      } else if (type == 6) {
        this.remarkTitle = '高管资质'
      } else if (type == 7) {
        this.remarkTitle = '资质及补贴信息、荣誉信息'
      } else if (type == 8) {
        this.remarkTitle = '知识产权'
      } else if (type == 9) {
        this.remarkTitle = '司法判决信息'
      } else if (type == 10) {
        this.remarkTitle = '高管及其他任职信息'
      } else if (type == 11) {
        this.remarkTitle = '股东信息'
      } else if (type == 12) {
        this.remarkTitle = '企业对外投资'
      }
      const { data } = await findRemarkList(this.remarkParams)
      if (data.code != 0) {
        return
      } else {
        this.remarkData = JSON.parse(JSON.stringify(data.remarkInformationRespList))
        this.remarkTotal = data.total
      }

    },
    remarkCurrent(val) {
      if (this.remarkParams.remarkType == 1) {
        this.remarkParams.pageNumber = val
      } else if (this.remarkParams.remarkType == 2) {
        this.remarkParams.pageNumber = val
      } else if (this.remarkParams.remarkType == 3) {
        this.remarkParams.pageNumber = val
      } else if (this.remarkParams.remarkType == 4) {
        this.remarkParams.pageNumber = val
      }
      this.findRemark(this.remarkParams.remarkType)
    },
    sureRemark() {
      this.$refs.remarkForm.validate(async valid => {
        if (valid) {
          const { data } = await addRemark(this.remarkForm)
          if (data.code != 0) return
          this.addRemarkVisible = false
          this.findRemark(this.remarkParams.remarkType)
        }
      })
    },
    closeRemark() {
      this.remarkParams.pageNumber = 1
    },
    closeRemarkDialog() {
      this.$refs.remarkForm.resetFields()
    },
    /**
     *会员档案
    */
    memberTabs(index) {
      this.memberIndex = index
      if (index == 0) {
        this.findUserMember()
      } else if (index == 2) {
        this.getInvoiceInfo()
      } else if (index == 3) {

      } else if (index == 4) {
        this.findFinancialInfo()
      } else if (index == 5) {
        this.findBusinessInfo()
      }
    },
    //切换tabs栏
    memberClick(tab) {
      if (tab.name == '1') {
        this.findUserMember()
      } else if (tab.name == '2') {
        this.isAnimationLeft = false,   //是否开启左箭头动画
          this.isAnimationRight = false,   //是否开启右箭头动画
          this.getCompanyInfo()
      } else if (tab.name == '4') {
        // this.$refs.adminQuse.getQuestionnaireInfo()
      }
    },
    // 查询会员信息
    async findUserMember() {
      if (this.roleType == 3) {
        const { data } = await userMemberInfo()
        if (data.code !== 0) return
        this.userInfoData = JSON.parse(JSON.stringify(data.sysUserMember))
        this.$refs.membershipInfo ? this.$refs.membershipInfo.getShipInfo(this.userInfoData) : ''
        this.$store.commit('saveMemberInfo', this.userInfoData)
      }
    },

    // 上传文件前校验
    beforeAvatarUpload(file) {

    },
    /**
     *发票信息
     */
    // 查询发票信息
    async getInvoiceInfo() {
      const { data } = await findInvoiceInfo(this.roleType == 3 ? this.userId : this.$route.query.id)
      if (data.code !== 0) return
      if (data.invoiceInformation == null) {
        this.isShowInvoice = false
        this.isEditInv = true
        this.isSaveInv = false
        this.isCancelInv = false
        this.isInvEdit1 = false
        this.isInvEdit2 = true
        this.isInvEdit3 = true
      } else {
        this.isShowInvoice = true
        this.isEditInv = false
        this.isSaveInv = true
        this.isCancelInv = true
        this.isInvEdit1 = true
        this.isInvEdit2 = false
        this.isInvEdit3 = false
        this.invoiceFormData = JSON.parse(JSON.stringify(data.invoiceInformation))
      }
    },
    //保存发票信息
    saveInvoice() {
      this.$refs.invoiceFormRef.validate(async (valid) => {
        if (valid) {
          const { data } = await addInvoiceInfo(this.invoiceFormData)
          if (data.code != 0) return
          this.getInvoiceInfo()
        }
      })
    },
    editInvoice() {
      this.isShowInvoice = false
      this.isEditInv = true
      this.isSaveInv = false
      this.isCancelInv = false
      this.isInvEdit1 = false
      this.isInvEdit2 = true
      this.isInvEdit3 = true
    },
    cancelInvoice() {
      this.$refs.invoiceFormRef.resetFields()
    },

    closeMonitorDialog() {
      this.$refs.monitorForm.resetFields()
      this.payFileList = []
    },
    //财务状况
    async findFinancialInfo() {
      const { data } = await findFinancialInformation(this.roleType == 3 ? this.userId : this.$route.query.id)
      if (data.code != 0) return
      this.assetsData = JSON.parse(JSON.stringify(data.financialList.slice(0, 4)))
    },
    //业务情况
    async findBusinessInfo() {
      const { data } = await findBusinessInformation(this.roleType == 3 ? this.userId : this.$route.query.id)
      if (data.code != 0) return
      this.busData = JSON.parse(JSON.stringify(data.businessInformationList.slice(0, 4)))
      this.busData.forEach((item, index) => {
        let businessData = []
        if (item.businessType.includes('[')) {
          businessData = JSON.parse(item.businessType)
        } else {
          businessData = [item.businessType]
        }
        if (businessData.includes('信用调查与服务')) {
          this.one = 1
        }
        if (businessData.includes('公共信用管理服务')) {
          this.two = 1
        }
        if (businessData.includes('信用评价')) {
          this.three = 1
        }
        if (businessData.includes('信用担保')) {
          this.four = 1
        }
        if (businessData.includes('保理')) {
          this.five = 1
        }
        if (businessData.includes('信用保险服务')) {
          this.six = 1
        }
        if (businessData.includes('商账管理服务')) {
          this.seven = 1
        }
        if (businessData.includes('大数据信用信息服务')) {
          this.eight = 1
        }
        if (businessData.includes('信用管理咨询')) {
          this.nine = 1
        }
      })
    },
    /**
     *公司信息
     */
    //公司信息tab栏
    companyTabs(index) {
      this.companyIndex = index
      if (index == 0) {
        this.getCompanyInfo()
      } else if (index == 1) {
        // this.getFileInfo()
      } else if (index == 2) {
        this.getQuaInfo()
      } else if (index == 3) {

      } else if (index == 4) {

      } else if (index == 5) {
        this.getNegFactData()
        this.getNegFactData1()
        this.getNegFactData2()
      } else if (index == 6) {
        this.getBrandData()
        this.getCopyRightData()
      } else if (index == 7) {
        this.getPartnerData()
      } else if (index == 8) {
        this.getInternationalData()
      }
    },
    moveLeftTab() {
      this.isAnimationLeft = true
      this.isAnimationRight = false
      this.isLeftBlock = 'none'
      this.isRightBlock = 'block'
    },
    moveRightTab() {
      this.isAnimationLeft = false
      this.isAnimationRight = true
      this.isLeftBlock = 'block'
      this.isRightBlock = 'none'
    },
    // 待办事项中跳转过来打开公司信息
    async todoCompanyInfo() {
      const { data } = await findCompanyInfo(this.roleType == 3 ? this.userId : this.$route.query.id)
      if (data.code != 0) return
      this.infoFormData = JSON.parse(JSON.stringify(data.companyInformation))
      this.isComEdit1 = false
      this.isComEdit2 = true
      this.isComEdit3 = true
      this.isEditCom = true
      this.isSaveCom = false
      this.isCancelCom = false
      this.isAdd = false
    },
    // 获取公司基本信息
    async getCompanyInfo() {
      // var str = '123'
      // str = str.replace('null', '')
      const { data } = await findCompanyInfo(this.roleType == 3 ? this.userId : this.$route.query.id)
      if (data.code != 0) return
      this.infoFormData = JSON.parse(JSON.stringify(data.companyInformation))

      if (this.infoFormData == null || (this.infoFormData.website == null && this.infoFormData.fax == null)) {
        if (this.roleType == 2) {
          this.isAdd = true
        } else if (this.roleType == 3) {
          this.isComEdit1 = false
          this.isComEdit2 = true
          this.isComEdit3 = true
          this.isEditCom = true
          this.isSaveCom = false
          this.isCancelCom = false
          this.isAdd = false
        }
      } else {
        if (this.$route.query.type == 3) {
          this.isComEdit1 = false
          this.isComEdit2 = true
          this.isComEdit3 = true
          this.isEditCom = true
          this.isSaveCom = false
          this.isCancelCom = false
          this.isAdd = false
        } else {
          this.isComEdit1 = true
          this.isComEdit2 = false
          this.isComEdit3 = false
          this.isEditCom = false
          this.isSaveCom = true
          this.isCancelCom = true
          this.isAdd = true
        }



      }
    },
    saveCompanyInfo() {
      this.$refs.infoFormRef.validate(async (valid) => {
        if (valid) {
          const { data } = await addCompanyInfo(this.infoFormData)
          if (data.code != 0) return
          this.infoFormData = {}
          this.isComEdit1 = true
          this.isComEdit2 = false
          this.isComEdit3 = false
          this.isEditCom = false
          this.isSaveCom = true
          this.isCancelCom = true
          this.isAdd = true
          this.getCompanyInfo()
        }
      })
    },
    editCompanyInfo() {
      // this.flag = false
      this.isComEdit1 = false
      this.isComEdit2 = true
      this.isComEdit3 = true
      this.isEditCom = true
      this.isSaveCom = false
      this.isCancelCom = false
      this.isAdd = false
    },
    cancelCompanyInfo() {
      this.$refs.infoFormRef.resetFields()
    },
    // 查询业务情况信息
    async getBusInfo() {
      const { data } = await findProBusType()
      if (data.code != 0) return
      this.busOptions = data.businessTypeList
    },
    selectPickerOne(a) {
      this.infoFormData.companyRegisteredAddress = a.province.value + ',' + a.city.value + ',' + a.area.value
    },
    inputOneChange(val) {
      this.infoFormData.companyRegisteredAddress = this.infoFormData.companyRegisteredAddress + ',' + val

    },
    selectPickerTwo(a) {
      this.infoFormData.actualBusinessAddress = a.province.value + ',' + a.city.value + ',' + a.area.value
    },
    inputTwoChange(val) {
      this.infoFormData.actualBusinessAddress = this.infoFormData.actualBusinessAddress + ',' + val
    },
    // 基本信息行业选择触发
    busNameChange(val) {
      this.infoFormData.businessTypeId = val.join(',')
    },
    /**
     *高管资质
    */
    async getQuaInfo() {
      this.quaParams.userId = this.roleType == 3 ? this.userId : this.$route.query.id
      const { data } = await findQuaInfo(this.quaParams)
      if (data.code != 0) return
      this.quaTableData = data.executiveQualificationList
      this.quaTotal = data.total
    },
    addQua() {
      this.addQuaVisible = true
      this.isQua = 1
    },
    handleQuaChange(val) {
      this.quaParams.pageNumber = val
      this.getQuaInfo()
    },

    quaSuccess(file, fileList) {
      if (fileList.status == 'success') {
        this.addQuaForm.file = fileList.response.fileUrl
        this.addQuaForm.fileName = fileList.name
        this.quaFileList.push({ name: fileList.name, url: fileList.response.fileUrl })
      }
    },
    removeQua(file) {
      const filePath = file.url
      // //使用findIndex来查找符合条件的索引
      const index = this.quaFileList.findIndex(item => item.url === filePath)
      // //移除索引对应的图片
      this.quaFileList.splice(index, 1)
    },
    openQuaDialog() {
      if (this.isQua == 1) {
        this.addQuaForm = {}
        this.quaFileList = []
      }
    },
    addQuaList() {
      this.addQuaForm.getTimeStr = this.$dayjs(this.addQuaForm.getTimeStr).format("YYYY-MM-DD HH:mm:ss")
      this.$refs.addQuaFormRef.validate(async valid => {
        if (valid) {
          const { data } = await addQuaInfo(this.addQuaForm)
          if (data.code != 0) return
          this.addQuaVisible = false
          this.getQuaInfo()
        }
      })
    },
    editQua(row) {
      this.isQua = 2
      this.addQuaVisible = true
      this.addQuaForm.id = this.roleType == 3 ? row.id : this.$route.query.id
      this.addQuaForm.executiveQualificationName = row.executiveQualificationName
      this.addQuaForm.getTimeStr = row.getTime
      this.quaFileList.push({ name: row.fileName, url: row.file })
    },
    deleteQua(id) {
      this.$confirm('确定删除当前数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async (res) => {
        if (res == 'confirm') {
          const { data } = await delQuaInfo(id)
          if (data.code !== 0) return
          this.getQuaInfo()
        }
      }).catch(() => {
        console.log('取消删除');
      });
    },
    closeQuaDialog() {
      this.$refs.addQuaFormRef.resetFields()
      this.quaFileList = []
    },
    /**
     *知识产权
    */
    async getBrandData() {
      const { data } = await findBrand(this.$route.query.comName)
      if (data.code != 0) return
      this.brandData = data.brandRepList
    },
    async getCopyRightData() {
      const { data } = await findCopyRight(this.$route.query.comName)
      if (data.code != 0) return
      this.copyRightData = data.copyRightRepList
    },
    /**
     *司法判决信息
    */
    async getNegFactData() {
      const { data } = await findNegFact(this.$route.query.comName)
      if (data.code != 0) return
      this.negFactData = data.negFactRepList
    },
    async getNegFactData1() {
      const { data } = await findNegFact1(this.$route.query.comName)
      if (data.code != 0) return
      this.negFactData1 = data.negFact1RepList
    },
    async getNegFactData2() {
      const { data } = await findNegFact2(this.$route.query.comName)
      if (data.code != 0) return
      this.negFactData2 = data.negFact2RepList
    },
    /**
     *股东信息&企业对外投资
    */
    async commonModule(name, type) {
      const { data } = await moduleInformation(name, type)
      if (data.code != 0) return
      if (type == 6) {
        this.partnerData = JSON.parse(data.jsonlist)
      } else if (type == 7) {
        this.internationalData = JSON.parse(data.jsonlist)
        this.internationalData.forEach(item => {
          item.INVESTDATE = this.$dayjs(item.INVESTDATE).format('YYYY-MM-DD')
        })
      }
    },
    getPartnerData() {
      this.commonModule(this.$route.query.comName, 6)
    },
    getInternationalData() {
      this.commonModule(this.$route.query.comName, 7)
    },
    // 高管资质下载文件
    downLoadQua(fileName, file) {
      downLoadFiles(fileName, file)
    },
    async initData() {
      if (this.roleType == 2 && this.$route.name == 'Management') {
        this.userId = this.$route.query.id
      }
      const { data } = await findSurveyYear(this.userId)
      if (data.code != 0) return
      this.yearData = data.yearList
      if (this.yearData == null) return
      this.yearData.sort(function (a, b) {
        return b - a
      })
    },
  },

  components: {
    Questionnaire,
    HonorInfo,
    Contact,
    Payment,
    Executive,
    MonitorDialog,
    NoteDialog,
    FileManagement,
    MembershipInfo
  }
}
</script>
<style lang='less' scoped>
@keyframes moveLeft {
  0% {
    right: 0;
  }
  100% {
    right: 100%;
  }
}
@keyframes moveRight {
  0% {
    right: 100%;
  }
  100% {
    right: 0;
  }
}
#management {
  position: relative;
  padding: 10px 32px;
  // 公共编辑保存取消按钮
  .editInvoice {
    text-align: right;
    margin-bottom: 25px;
  }
  .image {
    padding-left: 15px;
    vertical-align: middle;
    cursor: pointer;
  }

  .uploaadImg {
    display: inline-block;
    width: 134px;
    height: 34px;
    line-height: 34px;
    border-radius: 17px;
    border: solid 1px #0566cc;
    color: #0066cc;
    font-size: 16px;
    margin-right: 15px;
    cursor: pointer;
    img {
      vertical-align: middle;
      padding-right: 5px;
    }
  }
  .editFile {
    width: 80px;
    height: 36px;
    border-radius: 18px;
    color: #999;
  }
  .edit {
    background-image: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
    color: #fff;
  }
  .el-pagination {
    margin-top: 25px;
    text-align: right;
  }
  /deep/.member {
    .el-tabs__item {
      padding: 0;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
      border-color: #666 !important;
    }
  }
  // 会员档案和公司信息tab栏
  /deep/.memberProfile,
  .companyInfomation {
    position: relative;
    .el-divider--horizontal {
      margin: 20px 0;
    }
    .memberInfo {
      margin: 15px 0;
      span {
        padding-left: 50px;
      }
    }
    .memberTabs {
      width: 100%;
      height: 94px;
      background-color: #ffffff;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
      border-radius: 5px;
      border: solid 1px #e0e0e0;
      .memberCol {
        padding: 10px 0 10px 10px;
        height: 100%;
        .inRow {
          height: 100%;
          border-right: 1px dashed #e0e0e0;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            margin-right: 15px;
          }
          span {
            display: inline-block;
            margin-left: 15px;
            font-size: 16px;
            color: #464a53;
            font-weight: 550;
          }
        }
      }
      .activeStyle {
        border: solid 1px #0167cc;
        box-shadow: 0px 0px 5px 0px rgba(1, 103, 204, 0.5);
        border-radius: 5px;
        span {
          color: #409eff !important;
        }
      }
      .memberCol:nth-last-child(1) {
        .inRow {
          border-right: none;
        }
      }
      //公司信息tab栏显示
      .companyCol {
        span {
          color: #464a53 !important;
        }
      }
      // .pointerEvent {
      //   pointer-events: none;
      // }
    }
    /deep/.memberRow {
      width: 100%;
      .el-col {
        width: 16.6%;
      }
    }
    .memberContent {
      margin-top: 30px;
      .adminEdit {
        margin-left: 15px;
        vertical-align: middle;
        cursor: pointer;
      }
      .applyAdd {
        color: #999;
      }
      .assets {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        margin: 5px 0;
        .el-col {
          padding-left: 15px;
        }
        .addColor {
          color: #000;
        }
        .changeColor {
          font-size: 14px;
          color: #6a707e;
        }
      }
      .textCenter {
        text-align: center;
        // margin-left: 100px;
      }
      .addBgc {
        background: #fff;
      }
      .assetsOne {
        border-left: 4px solid #0066cc;
        color: #0066cc;
        font-size: 16px;
        padding-left: 10px;
        margin: 15px 0 15px 15px;
      }
      .titleTwo {
        color: #000;
        margin-left: 15px;
        font-weight: 550;
      }
      .titleThree {
        color: #000;
        margin: 20px 0 20px 0;
      }
      .title {
        padding-left: 30px;
      }
      /deep/.el-table.businessAddress tr {
        background: #f3f6f9 !important;
      }
    }
  }
  // 公司信息页面
  /deep/.companyInfomation {
    position: relative;
    .arrow {
      position: absolute;
      width: 20px;
      height: 94px;
      background-color: #e1e0e8;
      z-index: 999;
      cursor: pointer;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .leftArrow {
      right: 0;
      top: 0;
    }
    .rightArrow {
      left: 0;
      top: 0;
    }
    .adminTabs {
      width: 200%;
      .el-col {
        width: 10%;
      }
    }
    .isAnimationLeft {
      animation: moveLeft 0.5s linear forwards;
    }
    .isAnimationRight {
      animation: moveRight 0.5s linear forwards;
    }
    .demo-ruleForm {
      margin-top: 25px;
      .address {
        margin-left: 5px;
        width: 24%;
      }
    }

    .negFactStyle {
      margin: 15px 0;
    }
    .companyInfo {
      display: inline-block;
      padding-left: 30px;
    }
  }
  // 问卷调查
  .questionnaire {
    position: absolute;
    top: 1%;
    right: 2%;
    width: 140px;
    height: 36px;
    background-image: linear-gradient(-45deg, #0566cc 0%, #3793f4 100%);
    border-radius: 18px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }
  // 通知会员
  .noticeMember {
    right: 15%;
  }
  /deep/.addQuaVisible {
    .el-input {
      width: 70%;
    }
  }

  .companyProduct,
  .busVisitRecord {
    width: 100%;
    height: 600px;
    //二期删掉
    .delete {
      margin-top: 1%;
      img {
        width: 100%;
      }
    }
  }

  // 管理员备注
  /deep/.remarkVisible {
    .el-dialog__body {
      padding: 20px 20px 40px 20px;
    }
  }
  // 发票信息
  /deep/.invoiceFormData {
    .el-input {
      width: 80%;
    }
  }
}
/deep/.infoFormData {
  .el-textarea .el-textarea__inner {
    width: 30.5%;
  }
}
.required-tips {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
</style>